let header = document.querySelector(".header");
let headerBtn = document.querySelector(".header__navBtn.menu");
let headerBg = document.querySelector(".header__spmenu");

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
    noscroll(header.classList.contains("is-on"));
});

headerBg.addEventListener("click", (e) => {
    if (e.target === e.currentTarget) {
        header.classList.remove("is-on");
        noscroll(header.classList.contains("is-on"));
    }
});

function noscroll(bool) {
    if (bool) {
    } else {
    }
}

function disableScroll(event) {
    event.preventDefault();
}
